/**
 * Logout hook for code outside React, such as the API client's 401 handler. AppContextProvider sets
 * `logout`. Kept in its own module with no imports so `api` can use it without importing appContext:
 * that import made a cycle through apiClients/auth and the per-class API clients, and in the bundled
 * build a client could be created before `apiConfig` existed.
 */
export const globalLogout = {
  logout: () => {},
};
